export const API_NAME = "subscriptions";
export const ROUTE_NAME = "subscriptions";
export const COMPONENT_NAMES = ["subscriptions", "subscriptions"];
